import React from 'react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Ashwini Patil',
    company: 'Ra & Ra Counsel & Operations',
    message: 'Klyzen Ventures has been instrumental in transforming our IT infrastructure. A great partner to work with!',
  },
  {
    name: 'Harilal Patel',
    company: 'SH Automation PVT LTD',
    message: 'Their EdTech division helped us scale our learning platform to 10,000+ users seamlessly.',
  },
  {
    name: 'Niraj Chaudhari',
    company: 'N2C Digital Media LLP',
    message: 'We found a reliable technology and manufacturing partner in Klyzen. Highly recommend!',
  },
];

function Testimonials() {
  return (
    <section className="testimonials-section">
      <h2>What Our Clients Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card" key={index}>
            <p className="message">"{testimonial.message}"</p>
            <p className="author">– {testimonial.name}</p>
            <p className="company">{testimonial.company}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
